import samsung960 from 'assets/gear/workstation/samsung_960@2x.png';
import quadrop6000 from 'assets/gear/workstation/quadro_p6000@2x.png';
import intelE5 from 'assets/gear/workstation/intel_e5@2x.png';
import hpz840 from 'assets/gear/workstation/hpz840@2x.png';
import barracuda from 'assets/gear/workstation/barracuda@2x.png';

import shuttleXl from 'assets/gear/storage/shuttle_xl@2x.png';
import evreader from 'assets/gear/storage/evreader@2x.png';

import io4k from 'assets/gear/display/io4k@2x.png';
import hpDream from 'assets/gear/display/hp-dream@2x.png';
import flanders from 'assets/gear/display/flanders@2x.png';
import cintiq from 'assets/gear/display/cintiq@2x.png';

import logiMouse from 'assets/gear/accesories/logi_mouse@2x.png';
import logiKeyboard from 'assets/gear/accesories/logikeyboard@2x.png';
import palleteGear from 'assets/gear/accesories/pallete_gear@2x.png';

import a7x from 'assets/gear/audio/a7x_monitors.png';
import blueMic from 'assets/gear/audio/blue_mic@2x.png';
import presonus from 'assets/gear/audio/presonus@2x.png';
import as10subwoofer from 'assets/gear/audio/sa10_subwoofer.png';

//
import nvidia from 'assets/homeView/logos/nvidia.png';
import pallete from 'assets/homeView/logos/pallette.svg';
import intel from 'assets/homeView/logos/intel.png';
import samsung from 'assets/homeView/logos/samsung.png';
import adamaudio from 'assets/homeView/logos/adamaudio.png';
import aja from 'assets/homeView/logos/aja.png';
import blue from 'assets/homeView/logos/blue.png';
import fsi from 'assets/homeView/logos/flanders.png';
import gtech from 'assets/homeView/logos/gtech.svg';
import hp from 'assets/homeView/logos/hp.svg';
import logickey from 'assets/homeView/logos/logickey.svg';
import logitech from 'assets/homeView/logos/logitech.png';
import presonusLogo from 'assets/homeView/logos/presonus.png';
import seagate from 'assets/homeView/logos/seagate.png';
import wacom from 'assets/homeView/logos/wacom.png';

export default {
  gearSubsets: [{
    title: 'Workstation',
    description: 'The brains behind the operation. Powerful enough to handle anything you throw at it.',
    items: [
      {
        "price": 6050,
        "name": "HP Z840 Workstation",
        "image": hpz840,
        "shortName": "Z840",
        "description": "The brains of this operation is HP's most powerful and expandable workstation designed specifically with video editors in mind. Featuring 7 PCIe slots, 10 internal drive bays, 16 memory slots, and Thunderbolt, the Z840 is massively configurable and the top choice for this dream workstation.",
        "logo": hp,
        "url": "http://www8.hp.com/us/en/workstations/z840.html"
      },
      {
        "price": 2290,
        "name": "Intel® Xeon® E5-2637v4 CPU (2)",
        "image": intelE5,
        "shortName": "Xeon",
        "description": "Supercharge your post-production workflows and ensure you never miss a deadline with dual 3.5 GHz quad core Intel® Xeon® E5 processors that can handle multiple intense real-time effects while simultaneously rendering your most complex sequences.",
        "logo": intel,
        "url": "https://ark.intel.com/products/92983/Intel-Xeon-Processor-E5-2637-v4-15M-Cache-3_50-GHz"
      },
      {
        "price": 5499,
        "name": "NVIDIA® Quadro® P6000 Graphics Card",
        "image": quadrop6000,
        "shortName": "P6000",
        "description": "Combining the latest GPU, memory, and display technology, the NVIDIA® Quadro® P6000 is the most advanced pure professional graphics solution ever created to help you plow through massive video edits in no time.",
        "logo": nvidia,
        "url": "http://www.pny.com/nvidia-quadro-p6000"
      },
      {
        "price": 3600,
        "name": "Samsung 2TB 960 Pro M.2 Internal SSD (3)",
        "image": samsung960,
        "shortName": "960 Pro",
        "description": "3 x 2TB Samsung M.2 Pro PCI cards have been raided together in this advanced storage setup to support your operating system, scratch disk, and source footage while providing over 6 GB per second of throughput - enough to handle 181 simultaneous streams of 1080p ProRes 444.",
        "logo": samsung,
        "url": "https://www.samsung.com/us/computing/memory-storage/solid-state-drives/ssd-960-pro-m-2-2tb-mz-v6p2t0bw/"
      },
      {
        "price": 1200,
        "name": "Seagate BarraCuda Pro 10TB HDD (3)",
        "image": barracuda,
        "shortName": "BarraCuda",
        "description": "Maximize your internal storage with 3 x 10TB Seagate Barracuda Pro HDDs configured in RAID 5 array. These enterprise-class drives marry massive storage capacity with 7200-RPM spin speed for snappy performance to quickly access your archived files.",
        "logo": seagate,
        "url": "http://www.seagate.com/internal-hard-drives/creative-professionals/#edit"
      },
    ],
  }, {
    title: 'DISPLAYS & I/O',
    description: 'Reference grade monitoring with cinema quality IO',
    items: [
      {
        "price": 2798,
        "name": "HP Z27x DreamColor Studio 4K Displays (2)",
        "image": hpDream,
        "shortName": "DreamColor",
        "description": "Bring your ideas to life with dual HP DreamColor Z27X Studio Displays. These color-critical displays offer 10-bit color precision and are designed specifically for video, which means they match your broadcast monitor perfectly.",
        "logo": hp,
        "url": "http://store.hp.com/us/en/pdp/hp-dreamcolor-z27x-professional-display?jumpid=cp_r163_us/en/pc_comm/workstations/dreamcolor-displays/shopnow2"
      },
      {
        "price": 3995,
        "name": "Flanders Scientific DM240 Broadcast Monitor",
        "image": flanders,
        "shortName": "DM240",
        "description": "The OLED Flanders Scientific DM240 is a durable, lightweight, efficient and color critical professional broadcast monitor that offers advanced, real-time waveform, vector scope and a host of other monitoring solutions.",
        "logo": fsi,
        "url": "http://flandersscientific.com/DM240/"
      },
      {
        "price": 2800,
        "name": "Wacom Cintiq 27QHD Touch with Ergo Stand",
        "image": cintiq,
        "shortName": "Cintiq",
        "description": "The Cintiq 27QHD is Wacom's most advanced tablet/display combo that's nicely paired with an ergonomic stand. If you're designing, rotoscoping, or just want to feel a deeper connection to your work, the Cintiq is an amazing and immersive way to be creative.",
        "logo": wacom,
        "url": "https://us-store.wacom.com/Product/Cintiq-27QHD"
      },
      {
        "price": 2000,
        "name": "AJA Io 4K",
        "image": io4k,
        "shortName": "Io 4K",
        "description": "Featuring Thunderbolt 2, the AJA Io 4K marries your Z840 with all your display and monitoring solutions. Work seamlessly in SD, HD, Ultra HD or 4K. Whatever you need to capture or output, the I/O 4K handles with ease.",
        "logo": aja,
        "url": "https://www.aja.com/products/io-4k"
      },
    ],
  }, {
    title: 'EXTERNAL STORAGE',
    description: 'Store hours of 8K footage with confidence and access at lightning speed ',
    items:[
      {
        "price": 6100,
        "name": "G-Tech G-Speed Shuttle XL 64TB",
        "image": shuttleXl,
        "shortName": "Shuttle XL",
        "description": "The G-Speed Shuttle XL is an absolutely colossal external RAID featuring 8 bays, Thunderbolt 2, and 64 TB of storage supporting up to 1.3 Gigabytes per second of throughtput - enough to hold 112 hours of 8K RED Weapon Helium footage.",
        "logo": gtech,
        "url": "http://www.g-technology.com/products/g-speed-shuttle-xl"
      },
      {
        "price": 200,
        "name": "G-Tech ev Series Reader",
        "image": evreader,
        "shortName": "ev Reader",
        "description": "Shooting on RED? The ev Series Reader RED MINI-MAG® Edition is designed to optimize your RED camera workflow. With high-performance connectivity, you're able to transfer your RED MINI-MAG media onto your Z840 or G-Speed Shuttle XL at lightning speed.",
        "logo": gtech,
        "url": "http://www.g-technology.com/ev-series"
      },
    ],
  }, {
    title: 'Audio',
    description: "Half of video is audio, and we're giving you an earful",
    items:[
      {
        "price": 1498,
        "name": "ADAM Audio A7X Studio Monitors (2)",
        "image": a7x,
        "shortName": "A7X",
        "description": "ADAM's best-selling nearfield audio monitor is ideal for small studios. The A7X is an expertly balanced and versatile 2-way active monitor that features ADAM's new X-Art tweeter to maximize acoustic output.",
        "logo": adamaudio,
        "url": "https://www.adam-audio.com/en/ax-series/a7x/"
      },
      {
        "price": 1200,
        "name": "ADAM Audio Sub 10 MK2 Subwoofer",
        "image": as10subwoofer,
        "shortName": "Sub 10",
        "description": "Immerse yourself in the sound of your production. ADAM's 10\" subwoofer is designed specifically for small studios and packs a precise combination of low cutoff frequency and an undistorted high sound pressure level.",
        "logo": adamaudio,
        "url": "https://www.adam-audio.com/en/subwoofer/sub10-mk2/"
      },
      {
        "price": 300,
        "name": "Presonus Knob Station V2",
        "image": presonus,
        "shortName": "Knob",
        "description": "Take control of your audio monitors with this leading desktop speaker management solution. Control multiple inputs and outputs and track using headphone amplifiers so loud they're almost illegal — right from your desktop.",
        "logo": presonusLogo,
        "url": "https://www.presonus.com/products/Monitor-Station-V2"
      },
      {
        "price": 249,
        "name": "Yeti Pro Scratch V/O Mic",
        "image": blueMic,
        "shortName": "Yeti Pro",
        "description": "Every editor needs a solid microphone for recording scratch VO, and the Yeti Pro from Blue Mic hits the mark. It's the world's most versatile USB and XLR micrphone delivering detailed audio at more than 4X the resolution of a CD.",
        "logo": blue,
        "url": "http://www.bluemic.com/products/yeti-pro/"
      },
    ],
  }, {
    title: 'Accessories',
    description: 'Controls designed specifically for video editors using Adobe Premiere Pro',
    items: [
      {
        "price": 129,
        "name": "Logickeyboard Adobe Premiere Keyboard",
        "image": logiKeyboard,
        "shortName": "Keyboard",
        "description": "The best wireless shortcut keyboard to complete your edits in Adobe Premiere Pro CC at lightening speed. Ideal for editors who rely on complex custom key commands and value the benefits of a clearly labeled, color-coded keyboard.",
        "logo": logickey,
        "url": "http://logickeyboard.com/shop/adobe-premiere-pro-3053p.html",
      },
      {
        "price": 100,
        "name": "Logitech G703 Lightspeed Mouse",
        "image": logiMouse,
        "shortName": "G703",
        "description": "Fine-tune your edits with expert control from a mouse that's exceptionally precise and relentlessly consistent. With zero smoothing, filtering, or pixel rounding, the G703 gives you the confidence of quicker responses and more accurate targeting.",
        "logo": logitech,
        "url": "https://gaming.logitech.com/en-us/product/g703-wireless-gaming-mouse"
      },
      {
        "price": 499,
        "name": "Palette Gear Professional Kit",
        "image": palleteGear,
        "shortName": "Palette",
        "description": "Get hands-on control of your favorite software. Assign buttons, dials, and sliders directly to your most utilized functions - letting you edit the way you want without ever diverting your attention away from the art being created.",
        "logo": pallete,
        "url": "https://store.palettegear.com/collections/palette-kits/products/aluminum-professional-kit"
      },
    ]
  }],

  questions: {
    '1': {
      type: 'all',
      core: 'What’s your name?',
      items: {
        '1a': {
          title: 'First Name',
          type: 'input'
        },
        '1b': {
          title: 'Last Name',
          type: 'input'
        }
      },
    },
    '2': {
      core: 'Do you create video?',
      type: 'discrete',
      items: {
        '2a': {
          title: 'Yes - I create video professionally',
          type: 'checkbox',
        },
        '2b': {
          title: 'Yes - I create video, but not professionally',
          type: 'checkbox',
        },
        '2c': {
          title: 'I don’t create video, but my company does',
          type: 'checkbox',
        },
        '2d': {
          title: 'Neither my company nor I create video',
          type: 'checkbox',
        },
      }
    },

    /* Alt sets based on result from #2 (2b) */
    '3-2b': {
      type: 'discrete',
      core: 'How many videos do you create annually?',
      items: {
        '3-2b-a': {
          title: '1',
          type: 'checkbox'
        },
        '3-2b-b': {
          title: '2-5',
          type: 'checkbox'
        },
        '3-2b-c': {
          title: '6-10',
          type: 'checkbox'
        },
        '3-2b-d': {
          title: '11-50',
          type: 'checkbox'
        },
        '3-2b-e': {
          title: '50+',
          type: 'checkbox'
        },
      },
    },
    '4-2b': {
      type: 'discrete',
      core: 'What primary software do you use for video editing?',
      items: {
        '4-2b-a': {
          title: 'Adobe Premiere Pro',
          type: 'checkbox'
        },
        '4-2b-b': {
          title: 'Apple Final Cut Pro X',
          type: 'checkbox'
        },
        '4-2b-c': {
          title: 'DaVinci Resolve',
          type: 'checkbox'
        },
        '4-2b-d': {
          title: 'Avid Media Composer',
          type: 'checkbox'
        },
        '4-2b-e': {
          title: 'Other',
          type: 'arbitrary'
        },
      },
    },

    /*
    '5-2b': {
      type: 'some',
      core: 'What additional post production software do you use (select all that apply)?',
      items: {
        '5-2b-a': {
          title: 'Adobe After Effects',
          type: 'checkbox'
        },
        '5-2b-b': {
          title: 'Adobe Audition',
          type: 'checkbox'
        },
        '5-2b-c': {
          title: 'Adobe Media Encoder',
          type: 'checkbox'
        },
        '5-2b-d': {
          title: 'Adobe Photoshop',
          type: 'checkbox'
        },
        '5-2b-e': {
          title: 'Adobe Illustrator',
          type: 'checkbox'
        },
        '5-2b-f': {
          title: 'Avid Pro Tools',
          type: 'checkbox'
        },
        '5-2b-g': {
          title: 'Foundry Nuke',
          type: 'checkbox'
        },
        '5-2b-h': {
          title: 'Autodesk Smoke',
          type: 'checkbox'
        },
        '5-2b-i': {
          title: 'None of the above',
          type: 'checkbox'
        },
        '5-2b-j': {
          title: 'Other',
          type: 'arbitrary'
        },
      },
    },
    '6-2b': {
      type: 'discrete',
      core: 'How did you hear about the Dreamstation Giveaway?',
      items: {
        '6-2b-a': {
          title: 'A friend',
          type: 'checkbox',
        },
        '6-2b-b': {
          title: 'Email',
          type: 'checkbox',
        },
        '6-2b-c': {
          title: 'Facebook',
          type: 'checkbox',
        },
        '6-2b-d': {
          title: 'No Film School',
          type: 'checkbox',
        },
        '6-2b-e': {
          title: 'Pro Video Coalition',
          type: 'checkbox',
        },
        '6-2b-f': {
          title: 'RedShark News',
          type: 'checkbox',
        },
        '6-2b-g': {
          title: 'Twitter',
          type: 'checkbox',
        },
        '6-2b-h': {
          title: 'Other',
          type: 'arbitrary',
        },
      },
    },
    */

    /* Alt sets based on result from #2 (2d) */
    '3-2d': {
      type: 'all',
      core: 'What company do you work for?',
      items: {
        '3-2d-a': {
          title: 'Company Name',
          type: 'input'
        },
      },
    },
    '4-2d': {
      type: 'all',
      core: 'What is your job title?',
      items: {
        '4-2d-a': {
          title: 'Job Title',
          type: 'input'
        },
      },
    },
    /*
    '5-2d': {
      core: 'How did you hear about the Dreamstation Giveaway?',
      type: 'discrete',
      items: {
        '5-2d-a': {
          title: 'A friend',
          type: 'checkbox',
        },
        '5-2d-b': {
          title: 'Email',
          type: 'checkbox',
        },
        '5-2d-c': {
          title: 'Facebook',
          type: 'checkbox',
        },
        '5-2d-d': {
          title: 'No Film School',
          type: 'checkbox',
        },
        '5-2d-e': {
          title: 'Pro Video Coalition',
          type: 'checkbox',
        },
        '5-2d-f': {
          title: 'RedShark News',
          type: 'checkbox',
        },
        '5-2d-g': {
          title: 'Twitter',
          type: 'checkbox',
        },
        '5-2d-h': {
          title: 'Other',
          type: 'arbitrary',
        },
      },
    },
    */

    /* Regular sets*/
    '3': {
      core: 'Where do you work?',
      type: 'discrete',
      items: {
        '3-a': {
          title: 'Advertising agency',
          type: 'checkbox',
        },
        '3-b': {
          title: 'Media organization',
          type: 'checkbox',
        },
        '3-c': {
          title: 'Tech company',
          type: 'checkbox',
        },
        '3-d': {
          title: 'Brand',
          type: 'checkbox',
        },
        '3-e': {
          title: 'Production company',
          type: 'checkbox',
        },
        '3-f': {
          title: 'Post production company',
          type: 'checkbox',
        },
        '3-g': {
          title: 'School or university',
          type: 'checkbox',
        },
        '3-h': {
          title: 'Freelance creative',
          type: 'checkbox',
        },
        '3-i': {
          title: 'Government',
          type: 'checkbox',
        },
        '3-j': {
          title: 'Religious organization',
          type: 'checkbox',
        },
        '3-k': {
          title: 'Other',
          type: 'arbitrary',
        },
      }
    },


    '4': {
      core: 'What type of video does your company produce? (select all that apply)',
      type: 'some',
      items: {
        '4-a': {
          title: 'Features or short films',
          type: 'checkbox',
        },
        '4-b': {
          title: 'Television shows',
          type: 'checkbox',
        },
        '4-c': {
          title: 'Broadcast advertising',
          type: 'checkbox',
        },
        '4-d': {
          title: 'Web and social content',
          type: 'checkbox',
        },
        '4-e': {
          title: 'Web and social advertising',
          type: 'checkbox',
        },
        '4-f': {
          title: 'Education and training',
          type: 'checkbox',
        },
        '4-g': {
          title: 'Corporate industrial',
          type: 'checkbox',
        },
        '4-h': {
          title: 'Weddings',
          type: 'checkbox',
        },
        '4-i': {
          title: 'Events',
          type: 'checkbox',
        },
        '4-j': {
          title: 'Music videos',
          type: 'checkbox',
        },
        '4-k': {
          title: 'Stock videos',
          type: 'checkbox',
        },
        '4-l': {
          title: 'Other',
          type: 'arbitrary',
        }
      }
    },

    '5': {
      core: 'In which area of video do you work?',
      type: 'discrete',
      items: {
        '5a': {
          title: 'Production',
          type: 'checkbox',
        },
        '5b': {
          title: 'Post Production',
          type: 'checkbox',
        },
        '5c': {
          title: 'Business / Marketing',
          type: 'checkbox',
        },
        '5d': {
          title: 'Education',
          type: 'checkbox',
        }
      }
    },

    '6-5a': {
      core: 'What is your role in production?',
      type: 'discrete',
      items: {
        '6-5a-a': {
          title: 'Producer',
          type: 'checkbox',
        },
        '6-5a-b': {
          title: 'Director',
          type: 'checkbox',
        },
        '6-5a-c': {
          title: 'Cinematographer',
          type: 'checkbox',
        },
        '6-5a-d': {
          title: 'Creative director',
          type: 'checkbox',
        },
        '6-5a-e': {
          title: 'Digital imaging technician',
          type: 'checkbox',
        },
        '6-5a-f': {
          title: 'Production coordinator',
          type: 'checkbox',
        },
        '6-5a-g': {
          title: 'Visual designer',
          type: 'checkbox',
        },
        '6-5a-h': {
          title: 'Art director',
          type: 'checkbox',
        },
        '6-5a-i': {
          title: 'Camera operator',
          type: 'checkbox',
        },
        '6-5a-j': {
          title: 'Still photographer',
          type: 'checkbox',
        },
      }
    },

    '6-5b': {
      core: 'What is your role in post production?',
      type: 'discrete',
      items: {
        '6-5b-a': {
          title: 'Video editor',
          type: 'checkbox',
        },
        '6-5b-b': {
          title: 'Producer',
          type: 'checkbox',
        },
        '6-5b-c': {
          title: 'Coordinator',
          type: 'checkbox',
        },
        '6-5b-d': {
          title: 'Tech ops',
          type: 'checkbox',
        },
        '6-5b-e': {
          title: 'Colorist',
          type: 'checkbox',
        },
        '6-5b-f': {
          title: '3D & motion graphics artist',
          type: 'checkbox',
        },
        '6-5b-g': {
          title: 'VFX artist',
          type: 'checkbox',
        },
        '6-5b-h': {
          title: 'Animator',
          type: 'checkbox',
        },
        '6-5b-i': {
          title: 'Sound designer / editor',
          type: 'checkbox',
        },
      }
    },

    '6-5c': {
      core: 'What is your role in business / marketing?',
      type: 'discrete',
      items: {
        '6-5c-a': {
          title: 'Project manager',
          type: 'checkbox',
        },
        '6-5c-b': {
          title: 'Marketing manager',
          type: 'checkbox',
        },
        '6-5c-c': {
          title: 'Brand, communications & PR',
          type: 'checkbox',
        },
        '6-5c-d': {
          title: 'Sales or account manager',
          type: 'checkbox',
        },
        '6-5c-e': {
          title: 'Business executive',
          type: 'checkbox',
        },
        '6-5c-f': {
          title: 'Finance manager',
          type: 'checkbox',
        },
        '6-5c-g': {
          title: 'Lawyer',
          type: 'checkbox',
        },
      }
    },

    '6-5d': {
      core: 'What is your role in education?',
      type: 'discrete',
      items: {
        '6-5d-a': {
          title: 'Educator',
          type: 'checkbox',
        },
        '6-5d-b': {
          title: 'Program planner',
          type: 'checkbox',
        },
        '6-5d-c': {
          title: 'Student',
          type: 'checkbox',
        },
      }
    },

    '7': {
      core: 'How many employees at your organization create and/or review video?',
      type: 'discrete',
      items: {
        '7-a': {
          title: '1',
          type: 'checkbox',
        },
        '7-b': {
          title: '2-5',
          type: 'checkbox',
        },
        '7-c': {
          title: '6-10',
          type: 'checkbox',
        },
        '7-d': {
          title: '11-50',
          type: 'checkbox',
        },
        '7-e': {
          title: '50-200',
          type: 'checkbox',
        },
        '7-f': {
          title: '201-500',
          type: 'checkbox',
        },
        '7-g': {
          title: '501-1,000',
          type: 'checkbox',
        },
        '7-h': {
          title: '1,001+',
          type: 'checkbox',
        },
      }
    },

    '8': {
      core: 'How many videos does your company produce annually?',
      type: 'discrete',
      items: {
        '8-a': {
          title: '1-2',
          type: 'checkbox',
        },
        '8-b': {
          title: '3-5',
          type: 'checkbox',
        },
        '8-c': {
          title: '5-10',
          type: 'checkbox',
        },
        '8-d': {
          title: '11-50',
          type: 'checkbox',
        },
        '8-e': {
          title: '51-100',
          type: 'checkbox',
        },
        '8-f': {
          title: '101+',
          type: 'checkbox',
        },
      }
    },

    '9': {
      type: 'discrete',
      core: 'What primary software do you use for video editing?',
      items: {
        '9-a': {
          title: 'Adobe Premiere Pro',
          type: 'checkbox'
        },
        '9-b': {
          title: 'Adobe After Effects',
          type: 'checkbox'
        },
        '9-c': {
          title: 'Apple Final Cut Pro X',
          type: 'checkbox'
        },
        '9-d': {
          title: 'DaVinci Resolve',
          type: 'checkbox'
        },
        '9-e': {
          title: 'Avid Media Composer',
          type: 'checkbox'
        },
        '9-f': {
          title: 'Other',
          type: 'arbitrary'
        },
      },
    },

    /*
    '10': {
      type: 'some',
      core: 'What additional post production software do you use (select all that apply)?',
      items: {
        '10-a': {
          title: 'Adobe After Effects',
          type: 'checkbox'
        },
        '10-b': {
          title: 'Adobe Audition',
          type: 'checkbox'
        },
        '10-c': {
          title: 'Adobe Media Encoder',
          type: 'checkbox'
        },
        '10-d': {
          title: 'Adobe Photoshop',
          type: 'checkbox'
        },
        '10-e': {
          title: 'Adobe Illustrator',
          type: 'checkbox'
        },
        '10-f': {
          title: 'Avid Pro Tools',
          type: 'checkbox'
        },
        '10-g': {
          title: 'Foundry Nuke',
          type: 'checkbox'
        },
        '10-h': {
          title: 'Autodesk Smoke',
          type: 'checkbox'
        },
        '10-i': {
          title: 'None of the above',
          type: 'checkbox'
        },
        '10-j': {
          title: 'Other',
          type: 'arbitrary'
        },
      },
    },

    '11': {
      type: 'discrete',
      core: 'How did you hear about the Dreamstation Giveaway?',
      items: {
        '11-a': {
          title: 'A friend',
          type: 'checkbox',
        },
        '11-b': {
          title: 'Email',
          type: 'checkbox',
        },
        '11-c': {
          title: 'Facebook',
          type: 'checkbox',
        },
        '11-d': {
          title: 'No Film School',
          type: 'checkbox',
        },
        '11-e': {
          title: 'Pro Video Coalition',
          type: 'checkbox',
        },
        '11-f': {
          title: 'RedShark News',
          type: 'checkbox',
        },
        '11-g': {
          title: 'Twitter',
          type: 'checkbox',
        },
        '11-h': {
          title: 'Other',
          type: 'arbitrary',
        },
      },
    },
    */

  }
}



// WEBPACK FOOTER //
// ./src/constants/data.js